import { Injectable, ViewChild } from '@angular/core';
import { PaginationModel } from '@cv-invision/cv.component-library.ux';
import { GridApi, GridOptions } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
@Injectable()
export abstract class GridBaseComponent {
	@ViewChild('grid', { static: true }) grid: AgGridAngular;
	gridApi: GridApi;
	gridOptions: GridOptions;
	gridData: Array<any>;
	gridPagination = {
		pagination: {
			totalCount: 10,
			offset: 0,
			limit: 10
		}
	};
	public gridHeight: number;
	DEFAULT_GRID_HEIGHT = 695;
	DEFAULT_ROW_HEIGHT = 35;
	GRID_FIXED_MAX_HEIGHT = 76.4;

	protected constructor() {
		// default grid options
		this.gridOptions = {
			rowHeight: 40,
			rowSelection: 'single',
			defaultColDef: {
				resizable: true,
				suppressMovable: true
			},
			localeText: {
				noRowsToShow: 'No items to show',
				loadingOoo: 'Loading items ...'
			},
			columnDefs: []
		};
		this.gridData = [];
		this.gridHeight = this.DEFAULT_GRID_HEIGHT;
	}

	/**
	 * Returns the proper grid body height based on the number of total rows displayed.
	 * @param totalRows
	 */
	getGridHeight(totalRows: number): number {
		return totalRows > 0
			? (this.DEFAULT_ROW_HEIGHT * totalRows) + 45 // header static height (set by css style)
			: this.DEFAULT_GRID_HEIGHT;
	}

	/**
	 * When the grid has just started, we make the content to fit
	 */
	onInitializeGrid(params: any): void {
		this.gridApi = params.api;
		this.resizeToFitColumns();
		this.onGridReady();
	}

	/**
	 * Every time the view port has change, we ensure the columns fits properly
	 */
	resizeToFitColumns($event: any = null): void {
		this.gridApi.sizeColumnsToFit();
	}

	/**
	 * On Grid Pagination change.
	 * @param paginationModel
	 */
	onPagination(paginationModel: PaginationModel): void {
		this.gridPagination.pagination = paginationModel;
		this.onPaginationChange(paginationModel);
	}

	/**
	 * Implement to load the proper data into the gridData array variable.
	 */
	abstract loadGridData(): void;

	/**
	 * Override if needed.
	 * @param paginationModel
	 */
	onPaginationChange(paginationModel: PaginationModel): void {
		// Override if needed.
	}

	/**
	 * On Grid API ready. Override if needed.
	 */
	onGridReady(): void {
		// Override if needed.
	}
}
